import React from 'react';

function Home() {
    return (
        <h1>Page Not Found</h1>
    );
}

export default Home;